//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionMunicipalityJournals",
  components: {
    EmptyJournalsCollectionGrid: () => import("@/components/common/EmptyJournalsCollectionGrid"),
    Section: () => import("@/components/common/Section/index"),
    JournalCard: () => import("@/components/common/JournalCard/index"),
  },
  computed: {
    ...mapGetters({
      cityId: "municipality/id",
      journals: "journals/journals",
      pending: "journals/pending"
    }),
    show() {
      return this.pending || this?.journals?.length > 0;
    }
  },
  mounted() {
    const payload = {
      clear: true,
      params: {
        resolution: 'micro',
        city_id: this.cityId,
        count: 100500,
        lang: this.$i18n.locale
      }
    }
    if (this.cityId) {
      this.$store.dispatch("journals/fetch", payload)
    }
  }
};
